var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"v-spinner",attrs:{"height":"50","width":"50"}},[_c('circle',{staticClass:"path",attrs:{"cx":"25","cy":"25.2","r":"19.9","fill":"none","stroke-width":"3"}})])}
var staticRenderFns = []

export { render, staticRenderFns }